var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseInvoiceActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#FDCE57"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5h-9a1 1 0 0 0-1 1v12.5a.5.5 0 0 0 .5.5h.5a.499.499 0 0 0 .4-.2L9 17.334l1.1 1.466a.518.518 0 0 0 .8 0l1.1-1.466 1.1 1.466a.518.518 0 0 0 .8 0l1.1-1.466 1.1 1.466a.5.5 0 0 0 .4.2h.5a.5.5 0 0 0 .5-.5V6a1.001 1.001 0 0 0-1-1zm0 12.666L15.4 16.2a.518.518 0 0 0-.8 0l-1.1 1.466-1.1-1.466a.518.518 0 0 0-.8 0l-1.1 1.466L9.4 16.2a.518.518 0 0 0-.8 0l-1.1 1.466V6h9v11.666z",
    fill: "#020002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.41 8.29c.737 0 1.275.15 1.613.452.339.302.508.725.508 1.27 0 .247-.039.483-.117.707-.075.221-.2.418-.375.59-.174.169-.405.303-.691.402-.284.099-.635.148-1.051.148h-.61V14h-.937V8.29h1.66zm-.062.776h-.66v2.012h.511c.294 0 .544-.034.75-.101a.916.916 0 0 0 .469-.332c.107-.152.16-.35.16-.598 0-.33-.1-.577-.3-.738-.199-.162-.508-.243-.93-.243z",
    fill: "#020002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseInvoiceActiveIcon);
export default __webpack_public_path__ + "static/media/purchaseInvoiceActiveIcon.2ea76d75071ca716bf7f894fc78ac1cb.svg";
export { ForwardRef as ReactComponent };